module.exports = __webpack_public_path__ + "img/Laminating_1200x800.0d89d396.png";